import React from "react";
import { Link } from "react-router-dom";
import "../views/style/landing.css";
import { OPEN_EVENT } from "./CookieConsent";

function Footer() {
  return (
    <footer id="kontakt" className="landing__footer">
      <div>
        <strong>FinPilot.cz</strong> - Finanční inteligence pro vaše podnikání.
        <div style={{ marginTop: "10px", fontSize: "0.9rem", opacity: 0.8 }}>
          <span>Kontakt: info@finpilot.cz</span>
          <span style={{ margin: "0 10px" }}>|</span>
          <span>© 2026 FinPilot. Všechna práva vyhrazena.</span>
        </div>
        <div className="footer__legal-links">
          <Link to="/o-projektu">O projektu a metodice</Link>
          <Link to="/obory">Přehled oborů</Link>
          <Link to="/blog">Blog</Link>
          <a href="https://galikin.cz/radce" target="_blank" rel="noopener noreferrer">Prodej firmy (Galik In)</a>
          <Link to="/vop">VOP</Link>
          <Link to="/gdpr">GDPR</Link>
          <Link to="/cookies">Cookies</Link>
          <button type="button" className="footer__cookie-settings" onClick={() => window.dispatchEvent(new Event(OPEN_EVENT))}>
            Nastavení cookies
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
